export default __webpack_public_path__ + "static/media/FAngry.b8c96132.svg";